
{
  "familyId": "MET-GEW-WEGEN",
  "questions": [
    {
      "id": "MET-GEW-WEGEN-001",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Een weegschaal staat in evenwicht. Aan de ene kant liggen 3 gewichten van 100 gram. Hoeveel weegt het voorwerp aan de andere kant?",
      "context": null,
      "options": ["300 gram", "30 gram", "3 gram", "1.000 gram"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wegen_evenwicht_basis",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Als een weegschaal in evenwicht staat, wegen beide kanten even zwaar. Aan de ene kant: 3 × 100 gram = 300 gram. Dus het voorwerp weegt ook 300 gram.",
        "distractorExplanations": {
          "0": "Correct! 3 × 100 gram = 300 gram.",
          "1": "Fout: je hebt 3 × 10 gedaan in plaats van 3 × 100. Elk gewicht is 100 gram: 3 × 100 = 300 gram.",
          "2": "Fout: je hebt 3 × 1 gedaan. Elk gewicht is 100 gram: 3 × 100 = 300 gram.",
          "3": "Fout: 1.000 gram is 1 kilogram. Dat is meer dan 3 × 100 = 300 gram."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-002",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Op een weegschaal ligt een appel. De weegschaal wijst naar 150 gram. Je legt er nog een appel bij van 120 gram. Wat wijst de weegschaal nu?",
      "context": null,
      "options": ["270 gram", "30 gram", "150 gram", "120 gram"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wegen_optellen",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Je telt de gewichten op: 150 gram + 120 gram = 270 gram. De weegschaal wijst nu naar 270 gram.",
        "distractorExplanations": {
          "0": "Correct! 150 + 120 = 270 gram.",
          "1": "Fout: je hebt 150 - 120 gedaan. Je legt er een appel BIJ, dus tel je op: 150 + 120 = 270 gram.",
          "2": "Fout: 150 gram was het gewicht van alleen de eerste appel. Nu liggen er twee appels op de weegschaal.",
          "3": "Fout: 120 gram was het gewicht van de tweede appel. Nu liggen er twee appels op: 150 + 120 = 270 gram."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-003",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Een tas weegt 2 kg. Je stopt er een boek van 400 gram in. Hoeveel weegt de tas nu?",
      "context": null,
      "options": ["2.400 gram", "2.400 kg", "1.600 gram", "2 kg"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wegen_optellen_gemengde_eenheden",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Eerst alles in dezelfde eenheid: 2 kg = 2.000 gram. Dan optellen: 2.000 + 400 = 2.400 gram. De tas weegt nu 2.400 gram (= 2,4 kg).",
        "distractorExplanations": {
          "0": "Correct! 2 kg = 2.000 g, plus 400 g = 2.400 g.",
          "1": "Fout: 2.400 kg is veel te zwaar (dat is 2,4 ton!). Het antwoord is 2.400 gram.",
          "2": "Fout: je hebt 2.000 - 400 gedaan. Je stopt het boek erin, dus tel je op: 2.000 + 400 = 2.400 gram.",
          "3": "Fout: 2 kg is het gewicht van de lege tas. Met het boek erbij is het 2.000 + 400 = 2.400 gram."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-004",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Een weegschaal staat in evenwicht. Links liggen 2 gewichten van 500 gram. Rechts liggen 3 gewichten van hetzelfde gewicht. Hoe zwaar is elk gewicht rechts?",
      "context": null,
      "options": ["333 gram (afgerond)", "500 gram", "250 gram", "1.000 gram"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wegen_evenwicht_verdelen",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Links: 2 × 500 gram = 1.000 gram. De weegschaal staat in evenwicht, dus rechts is ook 1.000 gram. Rechts zijn 4 gewichten: 1.000 ÷ 4 = 250 gram per gewicht.",
        "distractorExplanations": {
          "0": "Fout: 333 gram klopt niet. Links: 2 × 500 = 1.000 gram. Rechts: 1.000 ÷ 4 = 250 gram per gewicht.",
          "1": "Fout: 500 gram zou betekenen dat rechts 4 × 500 = 2.000 gram is, maar links is maar 1.000 gram.",
          "2": "Correct! Links: 2 × 500 = 1.000 gram. Rechts: 1.000 ÷ 4 = 250 gram per gewicht.",
          "3": "Fout: 1.000 gram per gewicht zou rechts 4.000 gram zijn, maar links is maar 1.000 gram."
        }
      }
    },
    {
      "id": "MET-GEW-WEGEN-005",
      "familyId": "MET-GEW-WEGEN",
      "module": "Metriek",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "gewicht",
      "subSkill": "gewicht_wegen",
      "questionType": "multiple_choice",
      "question": "Een pakje boter weegt 250 gram. Hoeveel pakjes heb je nodig voor precies 1 kilogram?",
      "context": null,
      "options": ["4 pakjes", "2 pakjes", "10 pakjes", "5 pakjes"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "wegen_verdelen_kg",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "1 kilogram = 1.000 gram. 1.000 ÷ 250 = 4. Je hebt 4 pakjes van 250 gram nodig om 1 kilogram te maken. Controleer: 4 × 250 = 1.000 gram = 1 kg. ✓",
        "distractorExplanations": {
          "0": "Correct! 1.000 ÷ 250 = 4 pakjes. Controleer: 4 × 250 = 1.000 gram = 1 kg.",
          "1": "Fout: 2 pakjes is maar 2 × 250 = 500 gram, dat is maar een halve kilo.",
          "2": "Fout: 10 pakjes is 10 × 250 = 2.500 gram = 2,5 kg. Dat is te veel.",
          "3": "Fout: 5 pakjes is 5 × 250 = 1.250 gram. Dat is 250 gram te veel."
        }
      }
    }
  ]
}
